// Types
import { OnboardingObject } from "types/auth";

export const mixpanelEvents = {
  mergeDistinctIdAndUserId: "Merge Distinct ID and User ID",
  estateCreated: "Estate Created",
  estateDeleted: "Estate Deleted",
  segesOptIn: "SEGES Opt In",
  segesOptOut: "SEGES Opt Out",
  mapCreated: "Map Created",
  mapDeleted: "Map Deleted",
  mapAudienceActivated: "Map Audience Activated",
  mapAudienceDeactivated: "Map Audience Deactivated",
  audienceDocumentCreated: "Audience Document Created",
  audienceDocumentUpdated: "Audience Document Updated",
  audienceDocumentDeleted: "Audience Document Deleted",
  audienceDocumentTemplateCreated: "Audience Document Template Created",
  audienceDocumentTemplateUpdated: "Audience Document Template Updated",
  audienceDocumentTemplateDeleted: "Audience Document Template Deleted",
  mapStandDataProjected: "Map Stand Data Projected",
  pefcMapCertificationAdded: "Map PEFC Certification Added",
  pefcMapCertificationRemoved: "Map PEFC Certification Removed",
  fscMapCertificationAdded: "Map FSC Certification Added",
  fscMapCertificationRemoved: "Map FSC Certification Removed",
  ukwasMapCertificationAdded: "Map UKWAS Certification Added",
  ukwasMapCertificationRemoved: "Map UKWAS Certification Removed",
  projectCreated: "Project Created",
  projectDeleted: "Project Deleted",
  activityCreated: "Activity Created",
  activityUpdated: "Activity Updated",
  activityDeleted: "Activity Deleted",
  orgToOrgSubscriptionCreated: "Org to Org Subscription Created",
  orgToOrgSubscriptionDeleted: "Org to Org Subscription Deleted",
  noteCreated: "Note Created",
  noteDeleted: "Note Deleted",
  fileUploaded: "File Uploaded",
  fileDownloaded: "File Downloaded",
  fileDeleted: "File Deleted",
  mapLayerMenuOpened: "Map Layer Menu Opened",
  mapFilterMenuOpened: "Map Filter Menu Opened",
  mapFeatureOpened: "Map Feature Opened",
  mapOrProjectShared: "Map or Project Shared",
  teamMemberCreated: "Team Member Created",
  teamMemberDeleted: "Team Member Deleted",
  contactCreated: "Contact Created",
  contactDeleted: "Contact Deleted",
  inventoryCreated: "Inventory Created",
  inventoryUpdated: "Inventory Updated",
  inventoryDeleted: "Inventory Deleted",
  inventoryArchived: "Inventory Archived",
  inventoryMeasurementCreated: "Inventory Measurement Created",
  inventoryMeasurementUpdated: "Inventory Measurement Updated",
  brandingAssetUploaded: "Branding Asset Uploaded",
  brandingAssetDeleted: "Branding Asset Deleted",
  brandingFieldsUpdated: "Branding Fields Updated",
  aiAssistantChatNewThreadStarted: "AI Assistant Chat - New Thread Started",
  aiAssistantChatMessageSent: "AI Assistant Chat - Message Sent",
  aiAssistantChatMessageReceived: "AI Assistant Chat - Message Received",
  aiAssistantChatMessageError: "AI Assistant Chat - Message Error",
};

export function mapOnboardingStepToMixpanelUserOnbardingStep(onbObj: OnboardingObject): string {
  if (!onbObj || !onbObj.step) return "Step ?: Unknown";
  switch (onbObj.step) {
    case 0:
      return "Step 0: Welcome";
    case 1:
      return "Step 1: Heard about us";
    case 2:
      return "Step 2: Business info";
    case 3:
      return "Step 3: Questionnaire";
    case 4:
      return "Step 4: Finish";
    default:
      return "Step ?: Unknown";
  }
}
